export const BASE_URL = `${process.env.NX_DEPLOY_PATH}${process.env.NX_DEPLOY_SUFFIX}`;
export const VERSION = process.env.NX_APP_VERSION;
export const TOOL_NAME = 'image_rotate';
export const BUGSNAG_ID = process.env.NX_BUGSNAG_ID;
export const TRACKING_ID = process.env.NX_TRACKING_ID;
export const TRACKING_ID_4 = process.env.NX_TRACKING_ID_4;
export const HOTJAR_ID = Number(process.env.NX_HOTJAR_ID);
export const OPTIMIZE_ID = process.env.NX_OPTIMIZE_ID;
export const ONETRUST_ID = process.env.NX_ONETRUST_ID;
export const DEPLOY_PATH = process.env.NX_DEPLOY_PATH;

export const canonicalPath = 'image/rotate/';

export const appConfig = {
  accept: 'image/*',
  multiple: false,
  heroBannerImgSrc: 'images/herobanner-pic.png',
  heroBannerImgAlt: 'changeIt',
};
